import React from 'react'

function EditImage() {
  return <>edit</>
}

export default EditImage
